<template>
  <div class="p-8 bg-[#F4F7F9] min-h-screen font-sans">
    
    <header class="flex md:flex-row justify-between items-start md:items-center mb-10 gap-4">
      <div>
        <div class="flex items-center gap-2 mb-1">
          <span class="px-2 py-0.5 bg-blue-100 text-blue-600 text-[10px] font-black uppercase rounded-md">Phase d'intégration</span>
        </div>
        <h1 class="text-3xl font-extrabold text-[#222222] tracking-tight">Déploiement & Validation</h1>
        <p class="text-gray-500 font-medium">Suivi technique et mise en service du parc Datafuse.</p>
      </div>
      
      <div class="flex gap-3">
        <button class="bg-white border border-gray-200 p-3 rounded-xl shadow-sm hover:bg-gray-50">
          <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" /></svg>
        </button>
        <button class="bg-blue-500 text-white px-6 py-3 rounded-xl font-bold text-sm shadow-lg shadow-blue-100 flex items-center gap-2">
          Générer le PV de Recette
        </button>
      </div>
    </header>

    <div class="grid lg:grid-cols-12 gap-8">
      
      <div class="lg:col-span-7 space-y-8">
        
        <div class="bg-white rounded-[2rem] p-8 shadow-sm border border-gray-100 relative overflow-hidden">
          <div class="flex justify-between items-start relative z-10">
            <div>
              <h2 class="text-2xl font-black text-gray-900">MEDIA LINK SOLUTIONS</h2>
              <p class="text-sm font-bold text-dimotec-orange uppercase tracking-widest mt-1">Projet : INV-121225</p>
            </div>
            <div class="text-right">
              <p class="text-[10px] font-black text-gray-400 uppercase">Avancement Global</p>
              <p class="text-3xl font-black text-[#222222]">75%</p>
            </div>
          </div>
          <div class="w-full h-3 bg-gray-100 rounded-full mt-6 relative z-10 overflow-hidden">
            <div class="h-full bg-blue-500 transition-all duration-1000" style="width: 75%"></div>
          </div>
          <div class="absolute right-[-20px] top-[-20px] w-40 h-40 bg-gray-50 rounded-full opacity-50"></div>
        </div>

        <div class="bg-white rounded-[2rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-8 flex items-center gap-2">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            Validation Hardware & Connectivité
          </h3>

          <div class="space-y-4">
            <div v-for="(test, index) in tests" :key="index" 
                 class="flex items-center justify-between p-5 rounded-2xl transition-all border group"
                 :class="test.status === 'ok' ? 'bg-green-50/30 border-green-100' : 'bg-white border-gray-100 hover:border-dimotec-orange'">
              <div class="flex items-center gap-4">
                <div :class="test.status === 'ok' ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-400'" class="w-10 h-10 rounded-xl flex items-center justify-center transition-colors">
                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <p class="text-sm font-bold text-gray-800">{{ test.title }}</p>
                  <p class="text-xs text-gray-500">{{ test.desc }}</p>
                </div>
              </div>
              <button v-if="test.status !== 'ok'" class="px-4 py-2 bg-gray-100 rounded-lg text-[10px] font-black uppercase tracking-widest hover:bg-blue-500 hover:text-white transition-all">Valider</button>
              <span v-else class="text-[10px] font-black text-green-500 uppercase tracking-widest px-3">Confirmé</span>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-5 space-y-8">
        
        <div class="bg-[#222222] rounded-[2rem] p-8 text-white shadow-xl">
          <h3 class="text-sm font-black uppercase tracking-[0.2em] text-dimotec-orange mb-6">Formation & Transfert</h3>
          <div class="space-y-6">
            <div class="flex gap-4 items-start">
              <div class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold shrink-0">1</div>
              <div>
                <p class="text-sm font-bold">Formation SuperAdmin Client</p>
                <p class="text-xs text-gray-400 mt-1">Apprendre à gérer les files, les utilisateurs et les designs.</p>
                <div class="mt-3 flex items-center gap-2">
                  <span class="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span class="text-[10px] font-bold text-gray-300">Complété par Enzo Viana</span>
                </div>
              </div>
            </div>
            
            <div class="flex gap-4 items-start">
              <div class="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-xs font-bold shrink-0">2</div>
              <div>
                <p class="text-sm font-bold">Formation Opérateurs (Bornes/TV)</p>
                <p class="text-xs text-gray-400 mt-1">Utilisation de la console d'appel sur tablette.</p>
                <button class="mt-3 px-4 py-2 border border-white/20 rounded-lg text-[10px] font-bold hover:bg-white/5 transition">Marquer comme fait</button>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white rounded-[2rem] p-8 shadow-sm border border-gray-100">
          <h3 class="text-sm font-black uppercase tracking-[0.2em] text-gray-400 mb-6">Documentation Remise</h3>
          <div class="space-y-3">
            <div v-for="doc in ['Guide_Utilisateur_Bornes.pdf', 'Manuel_Admin_Datafuse.pdf', 'Maintenance_Imprimantes.pdf']" 
                 :key="doc"
                 class="flex items-center justify-between p-4 bg-gray-50 rounded-2xl group cursor-pointer hover:bg-gray-100 transition-colors">
              <div class="flex items-center gap-3">
                <svg class="w-5 h-5 text-dimotec-orange" fill="currentColor" viewBox="0 0 20 20"><path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" /></svg>
                <span class="text-xs font-bold text-gray-700">{{ doc }}</span>
              </div>
              <svg class="w-4 h-4 text-gray-300 group-hover:text-dimotec-orange transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
            </div>
          </div>
        </div>

        <div class="bg-red-50/50 border border-red-100 rounded-[2rem] p-6">
          <p class="text-[10px] font-black text-red-400 uppercase mb-3">Dernière anomalie de test</p>
          <div class="flex gap-3">
             <div class="w-1.5 h-auto bg-red-400 rounded-full"></div>
             <p class="text-xs font-medium text-red-700 leading-relaxed">
               Échec test impression (Borne #042) : Erreur de communication USB (ESC/POS). <br>
               <span class="font-bold underline cursor-pointer">Re-tenter le test</span>
             </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tests: [
        { title: "Liaison WebSocket", desc: "Test de connexion temps réel avec le backend", status: "ok" },
        { title: "Test Imprimante Thermique", desc: "Impression ticket test + coupe massicot", status: "error" },
        { title: "Rendu Multi-écrans", desc: "Vérification affichage sur TV 01 et TV 02", status: "ok" },
        { title: "Application Android (APK)", desc: "Stabilité de la navigation et mode Kiosque", status: "ok" },
        { title: "Lancement des Files", desc: "Vérification reset et incrémentation numéros", status: "pending" },
      ]
    }
  }
}
</script>